"use client";

import { SLATE_XP_REDRAWN_ICONS_BETA } from "@faire/web/slate/icons/lib/SLATE_XP_REDRAWN_ICONS";

import { Arrow as ArrowControl } from "./__internal__/Arrow.control";
import { Arrow as ArrowTreatment } from "./__internal__/Arrow.treatment";

export const Arrow = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: ArrowControl,
  treatment: ArrowTreatment,
});
